import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '../container';
import { useWindowSize } from '../../utils/helpers';
import { CanvasBackground } from '../home';
import { ABookDemoBtn } from '../abookdemo';

export const CustomCTA = ({ title, description }) => {
  const screenSize = useWindowSize();

  return (
    <section className="bg-black/3 py-10 sm:bg-white sm:py-20">
      <Container>
        <div className="relative z-[1] flex flex-col items-center justify-center overflow-hidden rounded-2xl border border-black/10 bg-white p-6 sm:p-16">
          <CanvasBackground
            className="top-24 -z-[1] rotate-[2.915deg] -scale-y-[1] sm:top-20"
            color="#212bc4"
            zoom={1.5}
            trail={true}
            trailOpacity={0.3}
          />
          <h2 className="mb-5 text-center text-azure-950 text-h2-xs sm:text-h2">
            {title}
          </h2>
          <p className="mb-6 text-center text-lg font-light text-black/80 sm:text-2xl">
            {description ? (
              description
            ) : (
              <>
                Eliminate bottlenecks. Automate faster. <br />
                Scale with confidence.
              </>
            )}
          </p>
          <div className="flex w-full flex-col items-center justify-center gap-2 sm:flex-row sm:gap-4">
            <ABookDemoBtn
              type="primary"
              fullWidth={screenSize.width < 768 ? true : false}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

CustomCTA.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};
